import { dynamic } from 'src/utils/ssr'

const getClientModule = () => import('src/clientRoutes/_app.contest._index')

export const handle = {
  name: 'contest-overview',
  track: { scene: 'contest' },
  showAppNav: true,
}

export function loader() {
  return null
}

export default dynamic(getClientModule, { ssr: false })
